import React from 'react';
import config from '~config';

import { ButtonRow, Button, Icon } from '~ui';

export default function DevHelp() {
  return (
    <ButtonRow>
      <Button asChild variant='ghost'>
        <a href={config.links.dev.github} target='_blank'>
          <Icon name='github' />
          Github
        </a>
      </Button>

      <Button asChild variant='link'>
        <a href={config.links.dev.index} target='_blank'>
          <Icon name='help' />
          API Documentation
        </a>
      </Button>
    </ButtonRow>
  );
}
